import { appConfig as selected } from '@app-config'
import type { AppConfig } from './app-config-schema'

// The build picks its config folder (APP_CONFIG, see vite.config.ts); code reads it from here.
export const appConfig: AppConfig = selected
